
{
  "title": "關於 WhatsGood HK",
  "subtitle": "您在香港尋找可靠本地服務的信賴指南",
  "mission": {
    "title": "我們的使命",
    "description": "WhatsGood HK 創建的目的是為了縮短外籍人士與香港值得信賴的本地服務提供者之間的距離。我們了解在新城市尋找可靠服務的挑戰，特別是當語言障礙和對本地企業的不熟悉讓整個過程變得困難重重時。"
  },
  "whatWeOffer": {
    "title": "我們提供什麼",
    "verified": {
      "title": "經過驗證的服務提供者",
      "description": "想要安心嗎？選擇帶有驗證徽章的提供者 - 這些檔案包含額外的檢查和功能。"
    },
    "directContact": {
      "title": "直接聯繫",
      "description": "透過 WhatsApp 直接與提供者聯繫 - 無需中間人，無額外費用。"
    },
    "reviews": {
      "title": "社群評論",
      "description": "來自真實客戶的真實評論幫助您做出明智的決定。"
    }
  },
  "whyChoose": {
    "title": "為什麼選擇 WhatsGood HK？",
    "local": {
      "title": "貼心且在地化",
      "description": "我們的平台專為香港量身打造，提供者熟悉本地需求、期望和工作方式。"
    },
    "expat": {
      "title": "外籍人士友好",
      "description": "我們的平台是為外籍人士設計的，讓您更容易找到會說英語的服務提供者。"
    },
    "transparent": {
      "title": "透明",
      "description": "無隱藏費用，無佣金收費 - 只是您與服務提供者之間的直接連接。"
    }
  }
}
